import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class KeycloakInterceptor implements HttpInterceptor {
  constructor(private keycloakService: KeycloakService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.keycloakService.isLoggedIn()) {
      const keycloakInstance = this.keycloakService.getKeycloakInstance();

      // Vérifiez si le token est expiré
      if (keycloakInstance.isTokenExpired()) {
        this.keycloakService.logout();
        return throwError(new Error('User is logged out'));
      }

      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + keycloakInstance.token,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Déconnectez l'utilisateur en cas d'erreur d'autorisation
          this.keycloakService.logout();
        }
        return throwError(error);
      })
    );
  }
}
